// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IndySoft Enterprise API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CompleteWorkOrderCommand } from '../models';
// @ts-ignore
import type { CompleteWorkOrderDetailCommand } from '../models';
// @ts-ignore
import type { CreateWorkOrderChargeCommand } from '../models';
// @ts-ignore
import type { CreateWorkOrderCommand } from '../models';
// @ts-ignore
import type { CreateWorkOrderDocumentCommand } from '../models';
// @ts-ignore
import type { IncompleteWorkOrderCommand } from '../models';
// @ts-ignore
import type { SkipWorkOrderDetailCommand } from '../models';
// @ts-ignore
import type { UpdateWorkOrderCommand } from '../models';
// @ts-ignore
import type { WorkOrderChargeViewModel } from '../models';
// @ts-ignore
import type { WorkOrderDetailViewModel } from '../models';
// @ts-ignore
import type { WorkOrderDocumentViewModel } from '../models';
// @ts-ignore
import type { WorkOrderViewModel } from '../models';
/**
 * WorkOrdersApi - axios parameter creator
 * @export
 */
export const WorkOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} jobNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberChargesGet: async (jobNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberChargesGet', 'jobNumber', jobNumber)
            const localVarPath = `/api/work-orders/{jobNumber}/charges`
                .replace(`{${"jobNumber"}}`, encodeURIComponent(String(jobNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {CreateWorkOrderChargeCommand} [createWorkOrderChargeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberChargesPost: async (jobNumber: string, createWorkOrderChargeCommand?: CreateWorkOrderChargeCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberChargesPost', 'jobNumber', jobNumber)
            const localVarPath = `/api/work-orders/{jobNumber}/charges`
                .replace(`{${"jobNumber"}}`, encodeURIComponent(String(jobNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWorkOrderChargeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {number} sequenceNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberChargesSequenceNumberDelete: async (jobNumber: string, sequenceNumber: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberChargesSequenceNumberDelete', 'jobNumber', jobNumber)
            // verify required parameter 'sequenceNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberChargesSequenceNumberDelete', 'sequenceNumber', sequenceNumber)
            const localVarPath = `/api/work-orders/{jobNumber}/charges/{sequenceNumber}`
                .replace(`{${"jobNumber"}}`, encodeURIComponent(String(jobNumber)))
                .replace(`{${"sequenceNumber"}}`, encodeURIComponent(String(sequenceNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {CompleteWorkOrderCommand} [completeWorkOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberCompletePost: async (jobNumber: string, completeWorkOrderCommand?: CompleteWorkOrderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberCompletePost', 'jobNumber', jobNumber)
            const localVarPath = `/api/work-orders/{jobNumber}/complete`
                .replace(`{${"jobNumber"}}`, encodeURIComponent(String(jobNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeWorkOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberDetailsGet: async (jobNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberDetailsGet', 'jobNumber', jobNumber)
            const localVarPath = `/api/work-orders/{jobNumber}/details`
                .replace(`{${"jobNumber"}}`, encodeURIComponent(String(jobNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {number} sequenceNumber 
         * @param {CompleteWorkOrderDetailCommand} [completeWorkOrderDetailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberDetailsSequenceNumberCompletePost: async (jobNumber: string, sequenceNumber: number, completeWorkOrderDetailCommand?: CompleteWorkOrderDetailCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberDetailsSequenceNumberCompletePost', 'jobNumber', jobNumber)
            // verify required parameter 'sequenceNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberDetailsSequenceNumberCompletePost', 'sequenceNumber', sequenceNumber)
            const localVarPath = `/api/work-orders/{jobNumber}/details/{sequenceNumber}/complete`
                .replace(`{${"jobNumber"}}`, encodeURIComponent(String(jobNumber)))
                .replace(`{${"sequenceNumber"}}`, encodeURIComponent(String(sequenceNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeWorkOrderDetailCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {number} sequenceNumber 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberDetailsSequenceNumberIncompletePost: async (jobNumber: string, sequenceNumber: number, body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberDetailsSequenceNumberIncompletePost', 'jobNumber', jobNumber)
            // verify required parameter 'sequenceNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberDetailsSequenceNumberIncompletePost', 'sequenceNumber', sequenceNumber)
            const localVarPath = `/api/work-orders/{jobNumber}/details/{sequenceNumber}/incomplete`
                .replace(`{${"jobNumber"}}`, encodeURIComponent(String(jobNumber)))
                .replace(`{${"sequenceNumber"}}`, encodeURIComponent(String(sequenceNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {number} sequenceNumber 
         * @param {SkipWorkOrderDetailCommand} [skipWorkOrderDetailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberDetailsSequenceNumberSkipPost: async (jobNumber: string, sequenceNumber: number, skipWorkOrderDetailCommand?: SkipWorkOrderDetailCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberDetailsSequenceNumberSkipPost', 'jobNumber', jobNumber)
            // verify required parameter 'sequenceNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberDetailsSequenceNumberSkipPost', 'sequenceNumber', sequenceNumber)
            const localVarPath = `/api/work-orders/{jobNumber}/details/{sequenceNumber}/skip`
                .replace(`{${"jobNumber"}}`, encodeURIComponent(String(jobNumber)))
                .replace(`{${"sequenceNumber"}}`, encodeURIComponent(String(sequenceNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skipWorkOrderDetailCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {string} documentCompany 
         * @param {string} documentName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDelete: async (jobNumber: string, documentCompany: string, documentName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDelete', 'jobNumber', jobNumber)
            // verify required parameter 'documentCompany' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDelete', 'documentCompany', documentCompany)
            // verify required parameter 'documentName' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDelete', 'documentName', documentName)
            const localVarPath = `/api/work-orders/{jobNumber}/documents/{documentCompany}/{documentName}`
                .replace(`{${"jobNumber"}}`, encodeURIComponent(String(jobNumber)))
                .replace(`{${"documentCompany"}}`, encodeURIComponent(String(documentCompany)))
                .replace(`{${"documentName"}}`, encodeURIComponent(String(documentName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {string} documentCompany 
         * @param {string} documentName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGet: async (jobNumber: string, documentCompany: string, documentName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGet', 'jobNumber', jobNumber)
            // verify required parameter 'documentCompany' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGet', 'documentCompany', documentCompany)
            // verify required parameter 'documentName' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGet', 'documentName', documentName)
            const localVarPath = `/api/work-orders/{jobNumber}/documents/{documentCompany}/{documentName}`
                .replace(`{${"jobNumber"}}`, encodeURIComponent(String(jobNumber)))
                .replace(`{${"documentCompany"}}`, encodeURIComponent(String(documentCompany)))
                .replace(`{${"documentName"}}`, encodeURIComponent(String(documentName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberDocumentsGet: async (jobNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberDocumentsGet', 'jobNumber', jobNumber)
            const localVarPath = `/api/work-orders/{jobNumber}/documents`
                .replace(`{${"jobNumber"}}`, encodeURIComponent(String(jobNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {CreateWorkOrderDocumentCommand} [createWorkOrderDocumentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberDocumentsPost: async (jobNumber: string, createWorkOrderDocumentCommand?: CreateWorkOrderDocumentCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberDocumentsPost', 'jobNumber', jobNumber)
            const localVarPath = `/api/work-orders/{jobNumber}/documents`
                .replace(`{${"jobNumber"}}`, encodeURIComponent(String(jobNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWorkOrderDocumentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberGet: async (jobNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberGet', 'jobNumber', jobNumber)
            const localVarPath = `/api/work-orders/{jobNumber}`
                .replace(`{${"jobNumber"}}`, encodeURIComponent(String(jobNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {IncompleteWorkOrderCommand} [incompleteWorkOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberIncompletePost: async (jobNumber: string, incompleteWorkOrderCommand?: IncompleteWorkOrderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberIncompletePost', 'jobNumber', jobNumber)
            const localVarPath = `/api/work-orders/{jobNumber}/incomplete`
                .replace(`{${"jobNumber"}}`, encodeURIComponent(String(jobNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(incompleteWorkOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {UpdateWorkOrderCommand} [updateWorkOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberPut: async (jobNumber: string, updateWorkOrderCommand?: UpdateWorkOrderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberPut', 'jobNumber', jobNumber)
            const localVarPath = `/api/work-orders/{jobNumber}`
                .replace(`{${"jobNumber"}}`, encodeURIComponent(String(jobNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateWorkOrderCommand} [createWorkOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersPost: async (createWorkOrderCommand?: CreateWorkOrderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/work-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWorkOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkOrdersApi - functional programming interface
 * @export
 */
export const WorkOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} jobNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersJobNumberChargesGet(jobNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkOrderChargeViewModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersJobNumberChargesGet(jobNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersJobNumberChargesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {CreateWorkOrderChargeCommand} [createWorkOrderChargeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersJobNumberChargesPost(jobNumber: string, createWorkOrderChargeCommand?: CreateWorkOrderChargeCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderChargeViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersJobNumberChargesPost(jobNumber, createWorkOrderChargeCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersJobNumberChargesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {number} sequenceNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersJobNumberChargesSequenceNumberDelete(jobNumber: string, sequenceNumber: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersJobNumberChargesSequenceNumberDelete(jobNumber, sequenceNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersJobNumberChargesSequenceNumberDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {CompleteWorkOrderCommand} [completeWorkOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersJobNumberCompletePost(jobNumber: string, completeWorkOrderCommand?: CompleteWorkOrderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersJobNumberCompletePost(jobNumber, completeWorkOrderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersJobNumberCompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersJobNumberDetailsGet(jobNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkOrderDetailViewModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersJobNumberDetailsGet(jobNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersJobNumberDetailsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {number} sequenceNumber 
         * @param {CompleteWorkOrderDetailCommand} [completeWorkOrderDetailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersJobNumberDetailsSequenceNumberCompletePost(jobNumber: string, sequenceNumber: number, completeWorkOrderDetailCommand?: CompleteWorkOrderDetailCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderDetailViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersJobNumberDetailsSequenceNumberCompletePost(jobNumber, sequenceNumber, completeWorkOrderDetailCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersJobNumberDetailsSequenceNumberCompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {number} sequenceNumber 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersJobNumberDetailsSequenceNumberIncompletePost(jobNumber: string, sequenceNumber: number, body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderDetailViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersJobNumberDetailsSequenceNumberIncompletePost(jobNumber, sequenceNumber, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersJobNumberDetailsSequenceNumberIncompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {number} sequenceNumber 
         * @param {SkipWorkOrderDetailCommand} [skipWorkOrderDetailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersJobNumberDetailsSequenceNumberSkipPost(jobNumber: string, sequenceNumber: number, skipWorkOrderDetailCommand?: SkipWorkOrderDetailCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderDetailViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersJobNumberDetailsSequenceNumberSkipPost(jobNumber, sequenceNumber, skipWorkOrderDetailCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersJobNumberDetailsSequenceNumberSkipPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {string} documentCompany 
         * @param {string} documentName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDelete(jobNumber: string, documentCompany: string, documentName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDelete(jobNumber, documentCompany, documentName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {string} documentCompany 
         * @param {string} documentName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGet(jobNumber: string, documentCompany: string, documentName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderDocumentViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGet(jobNumber, documentCompany, documentName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersJobNumberDocumentsGet(jobNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkOrderDocumentViewModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersJobNumberDocumentsGet(jobNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersJobNumberDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {CreateWorkOrderDocumentCommand} [createWorkOrderDocumentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersJobNumberDocumentsPost(jobNumber: string, createWorkOrderDocumentCommand?: CreateWorkOrderDocumentCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderDocumentViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersJobNumberDocumentsPost(jobNumber, createWorkOrderDocumentCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersJobNumberDocumentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersJobNumberGet(jobNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersJobNumberGet(jobNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersJobNumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {IncompleteWorkOrderCommand} [incompleteWorkOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersJobNumberIncompletePost(jobNumber: string, incompleteWorkOrderCommand?: IncompleteWorkOrderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersJobNumberIncompletePost(jobNumber, incompleteWorkOrderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersJobNumberIncompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {UpdateWorkOrderCommand} [updateWorkOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersJobNumberPut(jobNumber: string, updateWorkOrderCommand?: UpdateWorkOrderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersJobNumberPut(jobNumber, updateWorkOrderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersJobNumberPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateWorkOrderCommand} [createWorkOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersPost(createWorkOrderCommand?: CreateWorkOrderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersPost(createWorkOrderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkOrdersApi - factory interface
 * @export
 */
export const WorkOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkOrdersApiFp(configuration)
    return {
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersJobNumberChargesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberChargesGet(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberChargesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkOrderChargeViewModel>> {
            return localVarFp.apiWorkOrdersJobNumberChargesGet(requestParameters.jobNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersJobNumberChargesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberChargesPost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberChargesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderChargeViewModel> {
            return localVarFp.apiWorkOrdersJobNumberChargesPost(requestParameters.jobNumber, requestParameters.createWorkOrderChargeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersJobNumberChargesSequenceNumberDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberChargesSequenceNumberDelete(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberChargesSequenceNumberDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiWorkOrdersJobNumberChargesSequenceNumberDelete(requestParameters.jobNumber, requestParameters.sequenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersJobNumberCompletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberCompletePost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberCompletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderViewModel> {
            return localVarFp.apiWorkOrdersJobNumberCompletePost(requestParameters.jobNumber, requestParameters.completeWorkOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersJobNumberDetailsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberDetailsGet(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDetailsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkOrderDetailViewModel>> {
            return localVarFp.apiWorkOrdersJobNumberDetailsGet(requestParameters.jobNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberCompletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberDetailsSequenceNumberCompletePost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberCompletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderDetailViewModel> {
            return localVarFp.apiWorkOrdersJobNumberDetailsSequenceNumberCompletePost(requestParameters.jobNumber, requestParameters.sequenceNumber, requestParameters.completeWorkOrderDetailCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberIncompletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberDetailsSequenceNumberIncompletePost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberIncompletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderDetailViewModel> {
            return localVarFp.apiWorkOrdersJobNumberDetailsSequenceNumberIncompletePost(requestParameters.jobNumber, requestParameters.sequenceNumber, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberSkipPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberDetailsSequenceNumberSkipPost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberSkipPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderDetailViewModel> {
            return localVarFp.apiWorkOrdersJobNumberDetailsSequenceNumberSkipPost(requestParameters.jobNumber, requestParameters.sequenceNumber, requestParameters.skipWorkOrderDetailCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDelete(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDelete(requestParameters.jobNumber, requestParameters.documentCompany, requestParameters.documentName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGet(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderDocumentViewModel> {
            return localVarFp.apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGet(requestParameters.jobNumber, requestParameters.documentCompany, requestParameters.documentName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersJobNumberDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberDocumentsGet(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkOrderDocumentViewModel>> {
            return localVarFp.apiWorkOrdersJobNumberDocumentsGet(requestParameters.jobNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersJobNumberDocumentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberDocumentsPost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderDocumentViewModel> {
            return localVarFp.apiWorkOrdersJobNumberDocumentsPost(requestParameters.jobNumber, requestParameters.createWorkOrderDocumentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersJobNumberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberGet(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderViewModel> {
            return localVarFp.apiWorkOrdersJobNumberGet(requestParameters.jobNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersJobNumberIncompletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberIncompletePost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberIncompletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderViewModel> {
            return localVarFp.apiWorkOrdersJobNumberIncompletePost(requestParameters.jobNumber, requestParameters.incompleteWorkOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersJobNumberPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberPut(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderViewModel> {
            return localVarFp.apiWorkOrdersJobNumberPut(requestParameters.jobNumber, requestParameters.updateWorkOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersPost(requestParameters: WorkOrdersApiApiWorkOrdersPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderViewModel> {
            return localVarFp.apiWorkOrdersPost(requestParameters.createWorkOrderCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkOrdersApi - interface
 * @export
 * @interface WorkOrdersApi
 */
export interface WorkOrdersApiInterface {
    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberChargesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersJobNumberChargesGet(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberChargesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkOrderChargeViewModel>>;

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberChargesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersJobNumberChargesPost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberChargesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderChargeViewModel>;

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberChargesSequenceNumberDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersJobNumberChargesSequenceNumberDelete(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberChargesSequenceNumberDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberCompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersJobNumberCompletePost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberCompletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderViewModel>;

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberDetailsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersJobNumberDetailsGet(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDetailsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkOrderDetailViewModel>>;

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberCompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersJobNumberDetailsSequenceNumberCompletePost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberCompletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderDetailViewModel>;

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberIncompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersJobNumberDetailsSequenceNumberIncompletePost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberIncompletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderDetailViewModel>;

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberSkipPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersJobNumberDetailsSequenceNumberSkipPost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberSkipPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderDetailViewModel>;

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDelete(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGet(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderDocumentViewModel>;

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersJobNumberDocumentsGet(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkOrderDocumentViewModel>>;

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersJobNumberDocumentsPost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderDocumentViewModel>;

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersJobNumberGet(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderViewModel>;

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberIncompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersJobNumberIncompletePost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberIncompletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderViewModel>;

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersJobNumberPut(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderViewModel>;

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersPost(requestParameters?: WorkOrdersApiApiWorkOrdersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderViewModel>;

}

/**
 * Request parameters for apiWorkOrdersJobNumberChargesGet operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersJobNumberChargesGetRequest
 */
export interface WorkOrdersApiApiWorkOrdersJobNumberChargesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberChargesGet
     */
    readonly jobNumber: string
}

/**
 * Request parameters for apiWorkOrdersJobNumberChargesPost operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersJobNumberChargesPostRequest
 */
export interface WorkOrdersApiApiWorkOrdersJobNumberChargesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberChargesPost
     */
    readonly jobNumber: string

    /**
     * 
     * @type {CreateWorkOrderChargeCommand}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberChargesPost
     */
    readonly createWorkOrderChargeCommand?: CreateWorkOrderChargeCommand
}

/**
 * Request parameters for apiWorkOrdersJobNumberChargesSequenceNumberDelete operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersJobNumberChargesSequenceNumberDeleteRequest
 */
export interface WorkOrdersApiApiWorkOrdersJobNumberChargesSequenceNumberDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberChargesSequenceNumberDelete
     */
    readonly jobNumber: string

    /**
     * 
     * @type {number}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberChargesSequenceNumberDelete
     */
    readonly sequenceNumber: number
}

/**
 * Request parameters for apiWorkOrdersJobNumberCompletePost operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersJobNumberCompletePostRequest
 */
export interface WorkOrdersApiApiWorkOrdersJobNumberCompletePostRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberCompletePost
     */
    readonly jobNumber: string

    /**
     * 
     * @type {CompleteWorkOrderCommand}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberCompletePost
     */
    readonly completeWorkOrderCommand?: CompleteWorkOrderCommand
}

/**
 * Request parameters for apiWorkOrdersJobNumberDetailsGet operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersJobNumberDetailsGetRequest
 */
export interface WorkOrdersApiApiWorkOrdersJobNumberDetailsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDetailsGet
     */
    readonly jobNumber: string
}

/**
 * Request parameters for apiWorkOrdersJobNumberDetailsSequenceNumberCompletePost operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberCompletePostRequest
 */
export interface WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberCompletePostRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberCompletePost
     */
    readonly jobNumber: string

    /**
     * 
     * @type {number}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberCompletePost
     */
    readonly sequenceNumber: number

    /**
     * 
     * @type {CompleteWorkOrderDetailCommand}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberCompletePost
     */
    readonly completeWorkOrderDetailCommand?: CompleteWorkOrderDetailCommand
}

/**
 * Request parameters for apiWorkOrdersJobNumberDetailsSequenceNumberIncompletePost operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberIncompletePostRequest
 */
export interface WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberIncompletePostRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberIncompletePost
     */
    readonly jobNumber: string

    /**
     * 
     * @type {number}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberIncompletePost
     */
    readonly sequenceNumber: number

    /**
     * 
     * @type {object}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberIncompletePost
     */
    readonly body?: object
}

/**
 * Request parameters for apiWorkOrdersJobNumberDetailsSequenceNumberSkipPost operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberSkipPostRequest
 */
export interface WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberSkipPostRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberSkipPost
     */
    readonly jobNumber: string

    /**
     * 
     * @type {number}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberSkipPost
     */
    readonly sequenceNumber: number

    /**
     * 
     * @type {SkipWorkOrderDetailCommand}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberSkipPost
     */
    readonly skipWorkOrderDetailCommand?: SkipWorkOrderDetailCommand
}

/**
 * Request parameters for apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDelete operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDeleteRequest
 */
export interface WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDelete
     */
    readonly jobNumber: string

    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDelete
     */
    readonly documentCompany: string

    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDelete
     */
    readonly documentName: string
}

/**
 * Request parameters for apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGet operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGetRequest
 */
export interface WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGetRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGet
     */
    readonly jobNumber: string

    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGet
     */
    readonly documentCompany: string

    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGet
     */
    readonly documentName: string
}

/**
 * Request parameters for apiWorkOrdersJobNumberDocumentsGet operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersJobNumberDocumentsGetRequest
 */
export interface WorkOrdersApiApiWorkOrdersJobNumberDocumentsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDocumentsGet
     */
    readonly jobNumber: string
}

/**
 * Request parameters for apiWorkOrdersJobNumberDocumentsPost operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersJobNumberDocumentsPostRequest
 */
export interface WorkOrdersApiApiWorkOrdersJobNumberDocumentsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDocumentsPost
     */
    readonly jobNumber: string

    /**
     * 
     * @type {CreateWorkOrderDocumentCommand}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDocumentsPost
     */
    readonly createWorkOrderDocumentCommand?: CreateWorkOrderDocumentCommand
}

/**
 * Request parameters for apiWorkOrdersJobNumberGet operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersJobNumberGetRequest
 */
export interface WorkOrdersApiApiWorkOrdersJobNumberGetRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberGet
     */
    readonly jobNumber: string
}

/**
 * Request parameters for apiWorkOrdersJobNumberIncompletePost operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersJobNumberIncompletePostRequest
 */
export interface WorkOrdersApiApiWorkOrdersJobNumberIncompletePostRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberIncompletePost
     */
    readonly jobNumber: string

    /**
     * 
     * @type {IncompleteWorkOrderCommand}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberIncompletePost
     */
    readonly incompleteWorkOrderCommand?: IncompleteWorkOrderCommand
}

/**
 * Request parameters for apiWorkOrdersJobNumberPut operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersJobNumberPutRequest
 */
export interface WorkOrdersApiApiWorkOrdersJobNumberPutRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberPut
     */
    readonly jobNumber: string

    /**
     * 
     * @type {UpdateWorkOrderCommand}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberPut
     */
    readonly updateWorkOrderCommand?: UpdateWorkOrderCommand
}

/**
 * Request parameters for apiWorkOrdersPost operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersPostRequest
 */
export interface WorkOrdersApiApiWorkOrdersPostRequest {
    /**
     * 
     * @type {CreateWorkOrderCommand}
     * @memberof WorkOrdersApiApiWorkOrdersPost
     */
    readonly createWorkOrderCommand?: CreateWorkOrderCommand
}

/**
 * WorkOrdersApi - object-oriented interface
 * @export
 * @class WorkOrdersApi
 * @extends {BaseAPI}
 */
export class WorkOrdersApi extends BaseAPI implements WorkOrdersApiInterface {
    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberChargesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersJobNumberChargesGet(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberChargesGetRequest, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersJobNumberChargesGet(requestParameters.jobNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberChargesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersJobNumberChargesPost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberChargesPostRequest, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersJobNumberChargesPost(requestParameters.jobNumber, requestParameters.createWorkOrderChargeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberChargesSequenceNumberDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersJobNumberChargesSequenceNumberDelete(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberChargesSequenceNumberDeleteRequest, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersJobNumberChargesSequenceNumberDelete(requestParameters.jobNumber, requestParameters.sequenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberCompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersJobNumberCompletePost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberCompletePostRequest, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersJobNumberCompletePost(requestParameters.jobNumber, requestParameters.completeWorkOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberDetailsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersJobNumberDetailsGet(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDetailsGetRequest, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersJobNumberDetailsGet(requestParameters.jobNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberCompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersJobNumberDetailsSequenceNumberCompletePost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberCompletePostRequest, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersJobNumberDetailsSequenceNumberCompletePost(requestParameters.jobNumber, requestParameters.sequenceNumber, requestParameters.completeWorkOrderDetailCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberIncompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersJobNumberDetailsSequenceNumberIncompletePost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberIncompletePostRequest, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersJobNumberDetailsSequenceNumberIncompletePost(requestParameters.jobNumber, requestParameters.sequenceNumber, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberSkipPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersJobNumberDetailsSequenceNumberSkipPost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDetailsSequenceNumberSkipPostRequest, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersJobNumberDetailsSequenceNumberSkipPost(requestParameters.jobNumber, requestParameters.sequenceNumber, requestParameters.skipWorkOrderDetailCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDelete(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDeleteRequest, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDelete(requestParameters.jobNumber, requestParameters.documentCompany, requestParameters.documentName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGet(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGetRequest, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameGet(requestParameters.jobNumber, requestParameters.documentCompany, requestParameters.documentName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersJobNumberDocumentsGet(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDocumentsGetRequest, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersJobNumberDocumentsGet(requestParameters.jobNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersJobNumberDocumentsPost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDocumentsPostRequest, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersJobNumberDocumentsPost(requestParameters.jobNumber, requestParameters.createWorkOrderDocumentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersJobNumberGet(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberGetRequest, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersJobNumberGet(requestParameters.jobNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberIncompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersJobNumberIncompletePost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberIncompletePostRequest, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersJobNumberIncompletePost(requestParameters.jobNumber, requestParameters.incompleteWorkOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersJobNumberPut(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberPutRequest, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersJobNumberPut(requestParameters.jobNumber, requestParameters.updateWorkOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersPost(requestParameters: WorkOrdersApiApiWorkOrdersPostRequest = {}, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersPost(requestParameters.createWorkOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

